import React from 'react';
import ReactDOM from 'react-dom';
import debug from 'debug';
import '@/Proxies/CurrentSessionProxy';
import '@/styles/index.css';
import store from './store';
import Root from './containers/Root';

const mountPoint = document.getElementById('root');
const env = process.env.NODE_ENV;

if (env === 'production') {
  debug.disable();
} else {
  debug.enable('odara:*');
}

ReactDOM.render(<Root store={store} />, mountPoint);



// WEBPACK FOOTER //
// ./src/index.js